import { blockEl, unblockEl } from "./Block";
import popup from "./Popup";

const { __ } = wp.i18n;

export default class AjaxAddToCartSimple {
  constructor() {
    this.form = document.querySelector( '.cart' );
    this.variationsForm = document.querySelector( '.variations_form' );

    if ( this.variationsForm || ! this.form ) {
      return;
    }

    this.form = null;
    this.runRequest = false;

    this.addHandlers();
  }

  addHandlers() {
    document.body.addEventListener( 'submit', event => {
      if ( ! event.target.classList.contains( 'cart' ) ) {
        return;
      }

      event.preventDefault();
      this.form = event.target;
      this.onFormSubmit();
    } );
  }

  async onFormSubmit() {
    if ( ! this.form || this.runRequest ) {
      return;
    }

    this.runRequest = true;
    const addToCartBtn = this.form.querySelector( '.single_add_to_cart_button' );

    let data = {
      action: 'woocommerce_ajax_add_to_cart',
      product_id: addToCartBtn.value,
      quantity: '1',
    }

    blockEl( this.form );
    let response = await this.request( data );

    try {
      if ( ! response ) {
        return;
      }

      $( document.body ).trigger( 'added_to_cart', [ response.fragments, response.cart_hash, $( addToCartBtn ) ] );
    } catch ( e ) {
      console.log( e );
    } finally {
      unblockEl( this.form );
      this.runRequest = false;

      if ( ! response.error ) {
        this.openCartWidget();
      } else {
        this.openWarningPopup();
      }
    }
  }

  openWarningPopup() {
    popup.open( {
      title: __( 'Oh no...', 'canopia' ),
      type: 'warning',
      message: `<p>${ palram.i18n_cannot_add_to_cart_message }</p>`,
      link: {
        url: wc_add_to_cart_params.cart_url,
        text: wc_add_to_cart_params.i18n_view_cart,
      },
    } );
  }

  openCartWidget() {
    // Open cart widget after success product added to cart
    document.body.dispatchEvent( new CustomEvent( 'palram_open_cart_widget' ) );
    let closeTimer;

    if ( closeTimer !== 'undefined' ) {
      clearTimeout( closeTimer );
    }

    closeTimer = setTimeout( () => {
      // Close cart widget after success finally product added to cart
      document.body.dispatchEvent( new CustomEvent( 'palram_close_cart_widget' ) );
    }, 5000 );
  }

  async request( data ) {
    return $.ajax( {
      type: 'POST',
      url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'add_to_cart' ),
      data,
    } );
  }

}
